import { render, staticRenderFns } from "./OutboundDialog.vue?vue&type=template&id=5c8f4f1f&scoped=true"
import script from "./OutboundDialog.vue?vue&type=script&lang=js"
export * from "./OutboundDialog.vue?vue&type=script&lang=js"
import style0 from "./OutboundDialog.vue?vue&type=style&index=0&id=5c8f4f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f4f1f",
  null
  
)

export default component.exports